import {
    RETURN_REFUND_BY_MONTH_SUCCESS,
    RETURN_REFUND_BY_MONTH_LOADING
} from '../actions/ReturnRefundByMonthAction';

const initialState = {
    returnRefundByMonthData: null,
    isLoading: true    
};

const returnRefundByMonth = (state = initialState, action = {}) => {

    switch (action.type) {
        case RETURN_REFUND_BY_MONTH_SUCCESS:
            return {
                ...state,  returnRefundByMonthData: action.data, isLoading: false 
            };
        case RETURN_REFUND_BY_MONTH_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default returnRefundByMonth;
